package modysy

import org.scalajs.dom
import modysy.view.Color
import scala.scalajs.js

/**
  *
  * @param time
  */
class Clock(var time: Int = 0) {
  def getTimeText(): String = {
    var sec = time % 60
    var minutes = (time - sec) / 60
    if (time <= 0)
      return "0 : 00"
    else if (sec < 10 && sec >= 0)
      return minutes + " : 0" + sec
    return minutes + " : " + sec
  }

  var timeRef = js.Date.now()
  var timeBuffer: Int = 0
  var ignoreNext: Boolean = true

  /**
    *
    * @param time
    */
  def setTime(time: Int): Unit = {
    this.time = time
    this.timeBuffer = 0
    this.ignoreNext = true
  }

  def startClock(): Unit = {
    timeRef = js.Date.now()
    this.ignoreNext = true
  }

  def timeUp(): Boolean = {
    if (time < 0)
      return true
    return false
  }

  def updateTime(doIncrement: Boolean): Unit = {
    var timeDiff = js.Date.now() - timeRef
    if (doIncrement == true && ignoreNext == false)
      this.timeBuffer += timeDiff.toInt
    this.ignoreNext = false
    timeRef = js.Date.now()
    if (this.timeBuffer >= 1000) {
      this.timeBuffer -= 1000
      this.time -= 1
    }
  }

  def render(ctx: dom.CanvasRenderingContext2D): Unit = {
    ctx.font = "60px Arial"
    ctx.fillStyle = Color.White
    ctx.textAlign = "right"

    if (this.time < 30)
      ctx.fillStyle = Color.Red

    ctx.fillText(this.getTimeText(), 400, 0, 400)
  }

  def addTime(time: Int): Unit = {
    this.time += time;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/Clock.scala